import React, { useEffect, useRef } from 'react';

import { Field } from 'react-final-form';

const PhoneCodeInput = ({
  name,
  autoFocus = false,
  type = 'text',
  validate,
  focus,
  onPaste,
  onInput,
  setActiveFocus,
  index,
  form,
  values,
}) => {
  const inputRef = useRef();

  useEffect(() => {
    if (focus && name === focus && inputRef.current) {
      inputRef.current.focus();
    }
  });
  const handleKeyDown = (e) => {
    if (e.keyCode === 46 || e.keyCode === 8) {
      if (values[`code${index}`][0] === '' || values[`code${index}`] === '') {
        form.mutators.setValue(`code${index - 1}`, '');
      }
      setActiveFocus(index != 0 ? `code${index - 1}` : `code0`);
      form.mutators.setValue(`code${index}`, '');
    } else if ((e.keyCode >= 48 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105)) {
      setActiveFocus(`code${index + 1}`);
      form.mutators.setValue(`code${index}`, e.key);
    }
  };

  return (
    <div className="form-field">
      <Field name={name} validate={validate}>
        {({ input, meta }) => (
          <div className={`form-group ${meta.error && meta.touched ? 'error' : ''}`}>
            <input
              {...input}
              name={name}
              type="text"
              autoFocus={autoFocus}
              ref={inputRef}
              minLength="0"
              maxLength="1"
              inputMode="numeric"
              onPaste={onPaste}
              onInput={onInput}
              spellCheck={false}
              onKeyDown={handleKeyDown}
            />
          </div>
        )}
      </Field>
    </div>
  );
};

export default PhoneCodeInput;
